<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      class="tw-text-left tw-text-white tw-eko-dark"
      color="#212452"
      width="270"
    >
      <img
        class="my-img tw-mx-auto tw-mt-4 tw-mb-8"
        src="https://res.cloudinary.com/dldd8ucby/image/upload/v1580808183/Eko%20Carbon/logo_2.png"
      />

      <div id="tw-p-4">
        <router-link to="/offsetter">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-home tw-pr-1 md:tw-pr-3"></i> Home
          </p>
        </router-link>
        <router-link to="/offsetter/initial">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-calculator tw-pr-1 md:tw-pr-3"></i>
            Calculate Emmision
          </p>
        </router-link>
        <router-link to="/offsetter/projects/offset">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-folder tw-pr-1 md:tw-pr-3"></i>
            Offset Carbon
          </p>
        </router-link>
        <p
          @click="addOverlay"
          class="tw-block tw-cursor-pointer tw-text-white tw-mx-8 tw-my-6 tw-align-middle tw-text-lg tw-text-white tw-no-underline hover:tw-text-pink hover:tw-border-pink"
        >
          <i class="fas fa-certificate tw-pr-1 md:tw-pr-3"></i
          ><span class="tw-pb-1 md:tw-pb-0">Generate Certificate</span>
        </p>
        <router-link to="/offsetter/profile">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-user tw-pr-1 md:tw-pr-3"></i>
            Profile
          </p>
        </router-link>
        <p
          @click="logOut"
          class="tw-block tw-cursor-pointer tw-text-white tw-mx-8 tw-my-6 tw-align-middle tw-text-lg tw-text-white tw-no-underline hover:tw-text-pink hover:tw-border-pink"
        >
          <i class="fas fa-link tw-pr-1 md:tw-pr-3"></i
          ><span class="tw-pb-1 md:tw-pb-0">Logout</span>
        </p>
      </div>
    </v-navigation-drawer>
    <v-content>
      <div class="body">
        <template>
          <div>
            <v-app-bar color="white">
              <v-app-bar-nav-icon
                color="#2C316C"
                class="tw-hidden md:tw-block"
                @click.stop="drawer = !drawer"
              ></v-app-bar-nav-icon>

              <v-toolbar-title>Eko Carbon Exchange</v-toolbar-title>

              <v-spacer></v-spacer>

              <i class="fas fa-user-circle tw-text-3xl tw-text-idea-dark"></i>

              <v-menu left bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item>
                    <v-list-item-title class="tw-cursor-pointer" @click="logOut"
                      >Logout</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-app-bar>
          </div>
          <vue-element-loading
            v-if="loading"
            :active="loading"
            :is-full-screen="true"
          />
        </template>
        <div class="tw-mx-4">
          <router-view></router-view>
        </div>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import FileSaver from "file-saver";
export default {
  components: {
    // Sidebar
  },
  data() {
    return {
      user: {},
      token: "",
      drawer: true,
      admin: null,
      products: [],
      carbon: [],
      loading: false,
    };
  },
  methods: {
    ...mapActions(["setEmmisionValue"]),
    logOut() {
      localStorage.removeItem("eko-carbon-user");
      localStorage.removeItem("eko-carbon-token");
      this.setEmmisionValue(0);
      this.$router.push("/auth/login");
    },
    getCarbon() {
      const self = this;
      axios
        .get(`${this.$baseUrl}/carbon/offset/get/${this.user._id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.carbon = response.data.carbon;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data
            ? error.response.data.message
            : "An error occured";
          self.$swal("Error!", err_msg, "error");
        });
    },
    addOverlay() {
      const self = this;

      if (this.carbon.length < 1) {
        this.$swal(
          "Error!",
          "You need to offset Carbon before you generate a certificate",
          "error"
        );
      }
      this.loading = true;
      if (this.carbon[0].totalCarbonOffset > 0) {
        axios
          // .get(
          //   `https://res.cloudinary.com/dldd8ucby/image/upload/l_text:Sacramento_72_bold:${this.user.firstName}%20${this.user.lastName}/l_text:Sacramento_36_bold:${this.carbon[0].totalCarbonOffset},x_-60,y_85/Eko%20Carbon/certificate-1.jpg`
          // )
          .get(
            `https://res.cloudinary.com/ekoicentre/image/upload/l_text:Sacramento_172_bold:${this.user.firstName}%20${this.user.lastName}/l_text:Sacramento_86_bold:${this.carbon[0].totalCarbonOffset},x_-170,y_205/v1601550735/Eko-Carbon/ECX-Certificate_oxqg67.jpg`
          )
          .then(function (response) {
            console.log(response);
            FileSaver.saveAs(response.config.url, `Certificate.jpg`);
            this.loading = false;
          })
          .catch(function (err) {
            console.log(err);
            self.loading = false;
          });
      } else {
        self.$swal(
          "Error!",
          "Certificate cannot be generated for an offset value of 0",
          "error"
        );
        this.loading = false;
        console.log(this.loading);
      }
    },
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    if (!this.user || !this.token) {
      this.$router.push("/auth/login");
    }
    this.getCarbon();
  },
};
</script>

<style lang="css" scoped>
.my-img {
  width: 80%;
}
</style>
